// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.dropdown-item-has-icon[data-v-1dbf7318] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\nspan.dropdown-item-text[data-v-1dbf7318] {\n  padding-left: 5px;\n}\n.is-disabled[data-v-1dbf7318] {\n  opacity: 0.5;\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
